//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/SelectBodyList.js";
import "../GeometricUtilities/GeometricUtilities.ModlMotion.js";
import "../no/SelectNXObjectList.js";
import "../no/GeometricUtilities.js";
import "../no/SelectObjectList.js";
let d=[[[1,"BodiesReposition",0,"SelectBodyList",0],[0,"MoveToStationEnum",1,0],[0,"NewStationPart",1,"NXObject",0],[0,"ReferencePoint",1,"Point",0],[1,"RepositionMotion",0,"GeometricUtilities.ModlMotion",0],[1,"SelectEntityAdd",0,"SelectNXObjectList",0],[1,"SelectEntityRemove",0,"SelectNXObjectList",0],[1,"SelectObject",0,"SelectNXObjectList",0],[0,"SpecifyDieTip",1,"Direction",0],[0,"StationDistance",1,0],[0,"StationEnum",1,0],[0,"StationNameStr",1,0],[0,"StationNumber",1,0],[0,"WizardType",1,0]],[[[],"AddObject",{},0,0],[[],"RemoveObject",{},0,0],[[],"MoveToStation",{},0,0],[["currentStationPart"],"AddStationAfter",{},1,0],[["stationPart"],"DeleteStationPart",{},1,0],[[],"IncreaseStationParts",{},0,0],[[],"DecreaseStationParts",{},0,0],[["stationPartOcc","newStationName","newDistance"],"UpdateStation",{},3,0],[[],"CreateLayoutWithViews",{},0,0],[[],"ExitStationManagement",{},0,0],[[],"CreatePmiNote",{},0,0],[[],"CreatePMIForNewStation",{},0,0],[[],"RepositionBody",{},0,0]],[]];
SPLM.Tooling.LayoutManagementBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.LayoutManagementBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.LayoutManagementBuilder.StationItems = Object.freeze({
    "One" : "One", "Two" : "Two", "Three" : "Three"});

SPLM.Tooling.LayoutManagementBuilder.MoveToStationEnumeration = Object.freeze({
    "Op00" : "Op00", "Op10" : "Op10", "Op20" : "Op20"});

export default SPLM;